import LiveJobDetails from "../components/Sections/LiveJobsDetails1";

export default function LiveJobs1Page() {
  return (
      <>
          <LiveJobDetails />
  
      </>
  ) 
}